class AvParallaxScrolling {
    elements = [];
    frame = null;

    constructor() {
        this.elements = Array.from(document.querySelectorAll('.av-parallax-scrolling'));
        if (!this.elements.length) {
            return;
        }

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const scheduleUpdate = () => {
            if (this.frame !== null) {
                return;
            }

            this.frame = window.requestAnimationFrame(() => {
                this.frame = null;
                this.update();
            });
        };

        window.addEventListener('scroll', scheduleUpdate, { passive: true });
        window.addEventListener('resize', scheduleUpdate, { passive: true });
        this.reducedMotion.addEventListener('change', scheduleUpdate);

        // Hidden mobile galleries measure zero. Recalculate when CSS makes the
        // desktop presentation visible, even if the visitor has not scrolled.
        this.resizeObserver = new ResizeObserver(scheduleUpdate);
        this.elements.forEach(element => this.resizeObserver.observe(element));
        scheduleUpdate();
    }

    update() {
        const scrollPosition = window.scrollY;
        const reducedMotion = this.reducedMotion.matches;

        this.elements.forEach(element => {
            if (!element.offsetHeight) {
                return;
            }

            element.querySelectorAll('.av-parallax-scrolling__item').forEach(item => {
                const bg = item.querySelector('.av-parallax-scrolling__item__bg');
                if (!bg) {
                    return;
                }

                bg.style.height = `${item.offsetHeight + (reducedMotion ? 0 : 300)}px`;
                bg.style.transform = reducedMotion
                    ? 'none'
                    : `translateY(${(scrollPosition - item.offsetTop) * 0.234375}px)`;
            });
        });
    }
}

export default AvParallaxScrolling;
